export const locale = {
    lang: 'ds',
    data: {
        'Headers': {
            'MaterialPrice': 'Lager Pris',
            'OfferPrice': 'Tilbud Pris',
            'SuppliersItemPriceChangeList': 'Leverandoer Vare Pris Laveom liste'
        },
        "FIELDS": {
            'Supplier': 'Leverandør',
            'Percentage': 'Procent',
            'RetailPrice': 'Udsalgspris',
            'SalesPrice': 'Salgspris',
            'PurchasePrice': 'Indkøbspris',
            'PersonalPrice': 'Personale pris',
            'OfferPrice': 'Tilbud Pris',

            'SRNO': 'Sr nr.',
            "Edit": 'Redigere',
            "Delete": 'Slet',
            "ChangedBy": 'ModificereAf'
        },
        "BUTTONS": {
            'BTNSAVE': 'Gem',
            'BACK': 'Tilbage',
        },
        'MESSAGES': {
            'Added': 'Tilføjet med succes.',
            'Updated': 'Opdateret succesfuldt.',
            'Failed': 'Mislykkedes',
            'Deleted': 'Slettet med succes',
            'NORECORD': 'Intet optage fundet'
        },
        "VALIDATIONS": {
            'SupplierRequired': 'Vælg Leverandør',
            'PercentageRequired': 'Gå ind Procent'
        }
    }
}